import type { AuthTokens } from '@data';
import { AddInError } from '@utils-global';
import { processDialogEvent } from './processDialogEvent';
import { processLoginMessage } from './processLoginMessage';

export class DialogOpenError extends AddInError {
  constructor(message: string, context?: Record<string, unknown>) {
    super(message, context);
    this.name = 'DialogOpenError';
    Object.setPrototypeOf(this, DialogOpenError.prototype);
  }
}

type loginMSALParams = {
  userEmail: string;
  onTokens: (tokens: AuthTokens) => void;
  showToast: (translationKey: string, options?: any) => void;
};

export const loginWithDialogAPI = ({
  userEmail,
  onTokens,
  showToast,
}: loginMSALParams): Promise<void> => {
  return new Promise((resolve, reject) => {
    Office.context.ui.displayDialogAsync(
      `${process.env.APP_BASE_URL}/login.html?email=${userEmail}`,
      {
        height: 60,
        width: 30,
        promptBeforeOpen: false,
      },
      (result) => {
        if (result.status === Office.AsyncResultStatus.Succeeded) {
          const loginDialog = result.value;

          // listen to login
          loginDialog.addEventHandler(Office.EventType.DialogMessageReceived, (args) => {
            processLoginMessage({
              showToast,
              onTokens,
              closeDialog: loginDialog.close,
              args: args as { message: string; origin: string },
            });
          });

          // listen to login dialog interaction - will throw error if not supported
          try {
            loginDialog.addEventHandler(Office.EventType.DialogEventReceived, processDialogEvent);
            resolve();
          } catch (error) {
            reject(error);
          }
        } else {
          reject(new DialogOpenError('Failed to open login dialog', { code: result.error?.code }));
        }
      },
    );
  });
};
